export enum CalendarEventStatusEnum {
  None = 0,
  Declined = 1,
  Tentative = 2,
  Accepted = 3
}